import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';

const ThingsToKeepInMindSection = props => {
  const { languageData } = props;

  const items = [
    {
      en: `Day pass grants access to shared spaces only. Private offices and meeting rooms require a separate booking and may incur additional fees.`,
      es: `El day pass da acceso únicamente a espacios compartidos. Oficinas privadas y salas de reunión requieren una reserva separada y pueden generar cargos adicionales.`,
    },
    {
      en: `Desk availability is first-come, first-served. During peak hours, seating may be limited.`,
      es: `La disponibilidad de escritorios es por orden de llegada. Durante horas pico el espacio puede ser limitado.`,
    },
    {
      en: `Outside food is allowed in designated areas only. Please be respectful of shared spaces and clean up after use.`,
      es: `Se permite comida externa solo en áreas designadas. Por favor respeta los espacios compartidos y limpia después de usar.`,
    },
    {
      en: `This space may not meet all accessibility needs. Accessibility requests can be submitted in advance and are subject to approval and availability.`,
      es: `Este espacio puede no cubrir todas las necesidades de accesibilidad. Las solicitudes pueden enviarse con anticipación y están sujetas a aprobación y disponibilidad.`,
    },
    {
      en: `Coworking access is intended for individual use only. For group bookings or team access, please contact our community manager.`,
      es: `El acceso de coworking está destinado solo para uso individual. Para reservas grupales o de equipo, contacta al community manager.`,
    },
  ];

  return (
    <FlexContainer className=" width100 bgGradientReviewBlue180 borderrad14 pad24 flex-column">
      <Label
        className="text-18 margb18"
        style={{
          fontWeight: 700,
        }}
      >
        {languageData === 'EN'
          ? 'Things to Keep in Mind'
          : 'Cosas a Tener en Cuenta'}
      </Label>

      <FlexContainer className="flex-column">
        {items.map((item, index) => (
          <FlexContainer key={index} className="align-items-start margb16">
            <div
              style={{
                width: 6,
                height: 6,
                borderRadius: '50%',
                background: 'white',
                marginTop: 7,
                marginRight: 12,
                opacity: 0.9,
              }}
            />

            <Label
              className="text-13 lineHeight-1-6"
              style={{
                opacity: 0.9,
                fontWeight: 500,
              }}
            >
              {languageData === 'EN' ? item.en : item.es}
            </Label>
          </FlexContainer>
        ))}
      </FlexContainer>
    </FlexContainer>
  );
};

export default ThingsToKeepInMindSection;
